import { useEffect, UseEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from 'react-redux';
import {useLocation} from 'react-router-dom';
import { GetCacheKey } from "../../services/common/utils";
import Loadingcomponent from "../loader/loadingcomponent";
import ErrorMessage from "../messaging/errormessage";
import { getTemplate } from "./templates";
import { setThemeColor } from '../../reducer/appSlice';
import HeaderComponent from "../header";
import { setRefetchNojoomPage } from "../../reducer/nojoomSlice";
import NotificationComponent from "../home/notificationCards";
import {setNewUserProperties} from "../../reducer/actions";
import { setRefetchHomePage } from "../../reducer/utilitySlice";
import shadowimage from '../../../src/shadowthemeimage.png';
import shadowimage_ar from '../../../src/shadowthemeimage_ar.png';
import { SELECTED_LANG } from "../../services/common/Constants";
import { getItemOfSessionStorage } from "../../services/common/utils";
import PageShimmer from "../loader/skeletons/common/page-shimmer";
let containerClass = '';
let containerBg = '';

const PageMaster = ({ apiurl, urlKey, reqobj, enablecache = false,
     headertitle = "", isNojoomPageMaster, isXpressProfitPageMaster,
     ismoreaccount,ismoremenu, isManageAccount, linedetailsApi, isPassportCountries, isRoamingJourney= false }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [bgcolor, setbgcolor] = useState("");
    const {
        data: { data } = {},
        isLoading,
        error,
        isFetching,
        isError,
        isLoadingError,
        refetch
    } = useQuery([GetCacheKey(urlKey), apiurl, reqobj, {}], {
        retry: false,
        retryOnMount: false,
        // onSuccess:(resp)=>{
        //   //console.log("homeeee->Resp:"+JSON.stringify(resp))
        //   //console.log("homeeee->bgcolor:"+resp.data.bgcolor)
        //   try{
        //     setbgcolor(resp?.data?.bgcolor)
        //     sessionStorage.setItem("bgcolor",resp?.data?.bgcolor)
        // }catch(e){}

        // },
        cacheTime: enablecache ? 300000 : 0,
        staleTime: enablecache ? 300000 : 0,
        onSuccess: ({ data: resData }) => {
            setbgcolor(resData?.bgcolor);
            sessionStorage.setItem("bgcolor", resData?.bgcolor);
            dispatch(setThemeColor(resData?.bgcolor));
        }
    });

    const {
        appData: { themeColor },
        nojoomData: { refetchNojoomPage },
        utilityData: { refetchHomePage }
    } = useSelector((state) => state);
    // console.log(isLoading, isFetching);
    const customerprofile = useSelector(
        (state) => state?.userdata?.value?.customerprofile || {}
      );
      const isWifiCase = useSelector(
        (state) => state?.userdata?.value?.isWifiCase
      );
      const {
        userdata: { carouselBannerBgColor, isDefaultCarouselBanner },
      } = useSelector((state) => state);
    useEffect(() => {
        if(refetchNojoomPage){
            refetch();
            dispatch(setRefetchNojoomPage(false));
        }
    }, [refetchNojoomPage])

    useEffect(() => {
        if(refetchHomePage){
            refetch();
            dispatch(setRefetchHomePage(false));
        }
    }, [refetchHomePage])

    useEffect(()=>{
        try{
              if(isManageAccount){
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }
        }catch{}
    }, [isManageAccount])

    useEffect(()=>{
        if(data?.data?.pmsitem?.templatetype === '109' || data?.data?.pmsitem?.templatetype === '202')
        if(data?.data?.elementmeta?.isenrolled === 'F'){
            dispatch(setNewUserProperties({type:"Nojoom Enrolled", data: "No"}));
        }else{
            dispatch(setNewUserProperties({type:"Nojoom Enrolled", data:"Yes"}));
        }
    }, [data])

    const { t } = useTranslation()

    const notificationsNode = data?.data?.find(item => item?.templatetype === '100');

    const themeNode = data?.data?.find(item => item?.templatetype === '178') || null;

    if (isLoading || isFetching) {
        return (
            <>
     {/* <div class="dls13-theme-banner">
     <div class="swiper swiper-main-banner mb-5 scroll-pg-header" style={{background:'#e0e0e0',height:'1000px'}}>
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="main-banner-comp">
                    <div class="main-banner-cont align-top">
                        <div class="bannercont-comp1 swiper-banner-hed">
                       </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</div> */}

<PageShimmer />

            </>
            // <Loadingcomponent message={"Loading"} />
        );
    }

    if (error || isError ) {
        return <div class="body_container">

            <section class="">
                <div class="bottom_bg_section">
                    <div class="bottom_bg_section_container">
                        <img src="assets/images/assets_bg.jpg" alt="" />
                    </div>
                </div>
                <div class="center_section">
                    <div class="sec_top mt-160">
                        <div class="pse_md">
                            <div class="text-center mb-5">
                                <div class="mb-5">
                                    <picture>
                                        <img src={process.env.PUBLIC_URL + '/assets/images/error_red.svg'} width="{100px}" alt="" title="" />
                                    </picture>
                                </div>
                                <div>
                                    <h2 class="mb-2 page_title_v1 primary_color">{t("errorMsg")}</h2>
                                    <p class="mb-3 primary_14 dark_gray_color">{t("somethingwentwrong")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    }

    console.log('PageMaster_data ==>', data);

    //style={{ background: bgcolor ? bgcolor:'',height:350}}

    const isHomePage = location.pathname == "/home/index" || location.pathname == "/home";
    const isRoamingPage = location.pathname === "/passportmulticountry";
    if(isNojoomPageMaster){
        //containerClass = 'div-height';
        containerBg = bgcolor;
    }else if(isXpressProfitPageMaster){
        containerClass = '';
        containerBg = '';
    }else if(isHomePage){
        containerClass = '';
        //containerBg = carouselBannerBgColor || bgcolor;
    }else if( urlKey=="passportmulticountries"){
        containerClass = 'pse_sm';
        containerBg= ''
    }else if(isRoamingPage){
        containerClass = 'pse_sm';
        containerBg = '';
    }else if(ismoreaccount){
        containerBg = '';
    }else if(isManageAccount){
        containerClass = 'section-bg';
    }else if(isPassportCountries){
        containerClass = 'pse_sm';
        containerBg= ''
    }else if(isPassportCountries && !isRoamingJourney){
        containerClass = 'pse_sm';
        containerBg= ''
    }else if(isRoamingJourney){
        containerClass = '';
        containerBg='';
    }
    else{
        containerClass = 'pse_sm';
        containerBg = bgcolor;
    }

    return (
        <>
         {
            (isNojoomPageMaster || isXpressProfitPageMaster || ismoremenu || isManageAccount || urlKey=="passportmulticountries") ? <></> : 
            (ismoreaccount === "true" || urlKey=="passportcountries") ? <HeaderComponent type={26} color={bgcolor}></HeaderComponent>:
            <HeaderComponent type={2} color={isHomePage ? '#ffffff' : bgcolor} 
             icon = {isWifiCase}></HeaderComponent>
         }
           
            <div className={`${containerClass} ${isRoamingPage || isManageAccount || isPassportCountries ? "" : isNojoomPageMaster ? "" :'div-height'} `}
                style={{ backgroundColor: containerBg,
                    height :( isXpressProfitPageMaster || ismoreaccount || isRoamingPage || isHomePage || isManageAccount) ? '' : isNojoomPageMaster ? "100%" : 470 }}>
                {
                    notificationsNode && <div className="pse_sm"><NotificationComponent pmsitem={notificationsNode} isTheme={themeNode ? true : false} /></div>
                }
                
                {
                    data != null && data.data != null && data.data.length > 0 && (data.data.map((x) => (
                        <>
                            {getTemplate(x, data, isNojoomPageMaster, isXpressProfitPageMaster, isManageAccount, linedetailsApi, isRoamingJourney)}
                        </>
                    )))
                }

            </div>
        </>
    )
}
export default PageMaster;
